import { BillingPriceInterval } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs'

interface Props {
  selectedInterval: BillingPriceInterval
  onChange: (index: number) => void
}

const intervals = [BillingPriceInterval.Year, BillingPriceInterval.Month]

export const BillingIntervalTabs = ({ selectedInterval, onChange }: Props) => {
  const selectedTabIndex = intervals.indexOf(selectedInterval)

  return (
    <div className="flex justify-center">
      <Tabs.Group selectedIndex={selectedTabIndex} onChange={onChange}>
        <Tabs.List variant="plain" fullWidth={false}>
          <Tabs.Tab>
            <T
              defaultMessage="Annually"
              id="Admin.Billing.PlanCards.Annually"
            />
          </Tabs.Tab>
          <Tabs.Tab>
            <T defaultMessage="Monthly" id="Admin.Billing.PlanCards.Monthly" />
          </Tabs.Tab>
        </Tabs.List>
      </Tabs.Group>
    </div>
  )
}
